module.exports = __webpack_public_path__ + "img/tingchechang3.f3b7b174.jpg";